import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerComponent } from '../../components/date-picker/date-picker.component';
import { TablerIcon } from '../../components/tabler-icon/tabler-icon-list';
import { TablerIconComponent } from '../../components/tabler-icon/tabler-icon.component';
import { HeaderService } from '../../service/helper/header.service';
import { MapsPrintComponent } from '../maps/maps-print/maps-print.component';

@Component({
  selector: 'app-sandbox',
  imports: [
    CommonModule,
    MapsPrintComponent,
    TablerIconComponent,
    DatePickerComponent,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './sandbox.component.html',
  styleUrl: './sandbox.component.scss'
})
export class SandboxComponent {
  _TablerIcon = TablerIcon

  submission_date: string | null = null

  constructor(private headerService: HeaderService) { }

  ngOnInit() {
    this.headerService.setHeader('Sandbox', 'Test Subtitle Text');
  }
}
